/* eslint-disable react/jsx-props-no-spreading */
import { ButtonHTMLAttributes, ReactElement } from 'react';

import { Button } from './styles';

interface IProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
  textColor?: string;
  icon?: ReactElement | null;
  iconPosition?: 'left' | 'right';
  iconWhiteBackground?: boolean;
  iconBorderRadius?: boolean;
  color?: string;
  backgroundColor?: string;
  border?: string;
  fullWidth?: boolean;
  paddingButton?: any;
}

export const StyledButton: React.FC<IProps> = ({
  text,
  textColor,
  icon,
  iconPosition,
  iconWhiteBackground = false,
  iconBorderRadius = false,
  disabled = false,
  backgroundColor = undefined,
  border = undefined,
  fullWidth = false,
  paddingButton = 16,
  ...rest
}) => (
  <Button
    paddingButton={paddingButton}
    svgRadius={iconBorderRadius}
    svgWhiteBackground={iconWhiteBackground}
    disabled={disabled}
    backgroundColor={backgroundColor}
    border={border}
    fullWidth={fullWidth}
    {...rest}
  >
    {iconPosition === 'left' && icon}
    <p style={{color: textColor && textColor}}>{text}</p>
    {iconPosition === 'right' && icon}
  </Button>
);
